import React from "react";

const TournamentTypeContext = React.createContext(null);

export default TournamentTypeContext;
